import { __assign } from "tslib";
import { SENSITIVE_STRING, isa as __isa } from "@aws-sdk/smithy-client";
export var AbortIncompleteMultipartUpload;
(function (AbortIncompleteMultipartUpload) {
    AbortIncompleteMultipartUpload.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AbortIncompleteMultipartUpload.isa = function (o) { return __isa(o, "AbortIncompleteMultipartUpload"); };
})(AbortIncompleteMultipartUpload || (AbortIncompleteMultipartUpload = {}));
export var AbortMultipartUploadOutput;
(function (AbortMultipartUploadOutput) {
    AbortMultipartUploadOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AbortMultipartUploadOutput.isa = function (o) { return __isa(o, "AbortMultipartUploadOutput"); };
})(AbortMultipartUploadOutput || (AbortMultipartUploadOutput = {}));
export var AbortMultipartUploadRequest;
(function (AbortMultipartUploadRequest) {
    AbortMultipartUploadRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AbortMultipartUploadRequest.isa = function (o) { return __isa(o, "AbortMultipartUploadRequest"); };
})(AbortMultipartUploadRequest || (AbortMultipartUploadRequest = {}));
export var AccelerateConfiguration;
(function (AccelerateConfiguration) {
    AccelerateConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AccelerateConfiguration.isa = function (o) { return __isa(o, "AccelerateConfiguration"); };
})(AccelerateConfiguration || (AccelerateConfiguration = {}));
export var AccessControlPolicy;
(function (AccessControlPolicy) {
    AccessControlPolicy.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AccessControlPolicy.isa = function (o) { return __isa(o, "AccessControlPolicy"); };
})(AccessControlPolicy || (AccessControlPolicy = {}));
export var AccessControlTranslation;
(function (AccessControlTranslation) {
    AccessControlTranslation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AccessControlTranslation.isa = function (o) { return __isa(o, "AccessControlTranslation"); };
})(AccessControlTranslation || (AccessControlTranslation = {}));
export var AnalyticsAndOperator;
(function (AnalyticsAndOperator) {
    AnalyticsAndOperator.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AnalyticsAndOperator.isa = function (o) { return __isa(o, "AnalyticsAndOperator"); };
})(AnalyticsAndOperator || (AnalyticsAndOperator = {}));
export var AnalyticsConfiguration;
(function (AnalyticsConfiguration) {
    AnalyticsConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AnalyticsConfiguration.isa = function (o) { return __isa(o, "AnalyticsConfiguration"); };
})(AnalyticsConfiguration || (AnalyticsConfiguration = {}));
export var AnalyticsExportDestination;
(function (AnalyticsExportDestination) {
    AnalyticsExportDestination.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AnalyticsExportDestination.isa = function (o) { return __isa(o, "AnalyticsExportDestination"); };
})(AnalyticsExportDestination || (AnalyticsExportDestination = {}));
export var AnalyticsFilter;
(function (AnalyticsFilter) {
    AnalyticsFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AnalyticsFilter.isa = function (o) { return __isa(o, "AnalyticsFilter"); };
})(AnalyticsFilter || (AnalyticsFilter = {}));
export var AnalyticsS3BucketDestination;
(function (AnalyticsS3BucketDestination) {
    AnalyticsS3BucketDestination.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AnalyticsS3BucketDestination.isa = function (o) { return __isa(o, "AnalyticsS3BucketDestination"); };
})(AnalyticsS3BucketDestination || (AnalyticsS3BucketDestination = {}));
export var Bucket;
(function (Bucket) {
    Bucket.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Bucket.isa = function (o) { return __isa(o, "Bucket"); };
})(Bucket || (Bucket = {}));
export var BucketAlreadyExists;
(function (BucketAlreadyExists) {
    BucketAlreadyExists.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    BucketAlreadyExists.isa = function (o) { return __isa(o, "BucketAlreadyExists"); };
})(BucketAlreadyExists || (BucketAlreadyExists = {}));
export var BucketAlreadyOwnedByYou;
(function (BucketAlreadyOwnedByYou) {
    BucketAlreadyOwnedByYou.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    BucketAlreadyOwnedByYou.isa = function (o) { return __isa(o, "BucketAlreadyOwnedByYou"); };
})(BucketAlreadyOwnedByYou || (BucketAlreadyOwnedByYou = {}));
export var BucketLifecycleConfiguration;
(function (BucketLifecycleConfiguration) {
    BucketLifecycleConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    BucketLifecycleConfiguration.isa = function (o) { return __isa(o, "BucketLifecycleConfiguration"); };
})(BucketLifecycleConfiguration || (BucketLifecycleConfiguration = {}));
export var BucketLoggingStatus;
(function (BucketLoggingStatus) {
    BucketLoggingStatus.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    BucketLoggingStatus.isa = function (o) { return __isa(o, "BucketLoggingStatus"); };
})(BucketLoggingStatus || (BucketLoggingStatus = {}));
export var CommonPrefix;
(function (CommonPrefix) {
    CommonPrefix.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CommonPrefix.isa = function (o) { return __isa(o, "CommonPrefix"); };
})(CommonPrefix || (CommonPrefix = {}));
export var CompletedMultipartUpload;
(function (CompletedMultipartUpload) {
    CompletedMultipartUpload.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CompletedMultipartUpload.isa = function (o) { return __isa(o, "CompletedMultipartUpload"); };
})(CompletedMultipartUpload || (CompletedMultipartUpload = {}));
export var CompletedPart;
(function (CompletedPart) {
    CompletedPart.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CompletedPart.isa = function (o) { return __isa(o, "CompletedPart"); };
})(CompletedPart || (CompletedPart = {}));
export var CompleteMultipartUploadOutput;
(function (CompleteMultipartUploadOutput) {
    CompleteMultipartUploadOutput.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING }))); };
    CompleteMultipartUploadOutput.isa = function (o) { return __isa(o, "CompleteMultipartUploadOutput"); };
})(CompleteMultipartUploadOutput || (CompleteMultipartUploadOutput = {}));
export var CompleteMultipartUploadRequest;
(function (CompleteMultipartUploadRequest) {
    CompleteMultipartUploadRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CompleteMultipartUploadRequest.isa = function (o) { return __isa(o, "CompleteMultipartUploadRequest"); };
})(CompleteMultipartUploadRequest || (CompleteMultipartUploadRequest = {}));
export var Condition;
(function (Condition) {
    Condition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Condition.isa = function (o) { return __isa(o, "Condition"); };
})(Condition || (Condition = {}));
export var ContinuationEvent;
(function (ContinuationEvent) {
    ContinuationEvent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ContinuationEvent.isa = function (o) { return __isa(o, "ContinuationEvent"); };
})(ContinuationEvent || (ContinuationEvent = {}));
export var CopyObjectOutput;
(function (CopyObjectOutput) {
    CopyObjectOutput.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING })), (obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING }))); };
    CopyObjectOutput.isa = function (o) { return __isa(o, "CopyObjectOutput"); };
})(CopyObjectOutput || (CopyObjectOutput = {}));
export var CopyObjectRequest;
(function (CopyObjectRequest) {
    CopyObjectRequest.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign(__assign(__assign({}, obj), (obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING })), (obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING })), (obj.CopySourceSSECustomerKey && { CopySourceSSECustomerKey: SENSITIVE_STRING })), (obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING }))); };
    CopyObjectRequest.isa = function (o) { return __isa(o, "CopyObjectRequest"); };
})(CopyObjectRequest || (CopyObjectRequest = {}));
export var CopyObjectResult;
(function (CopyObjectResult) {
    CopyObjectResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CopyObjectResult.isa = function (o) { return __isa(o, "CopyObjectResult"); };
})(CopyObjectResult || (CopyObjectResult = {}));
export var CopyPartResult;
(function (CopyPartResult) {
    CopyPartResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CopyPartResult.isa = function (o) { return __isa(o, "CopyPartResult"); };
})(CopyPartResult || (CopyPartResult = {}));
export var CORSConfiguration;
(function (CORSConfiguration) {
    CORSConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CORSConfiguration.isa = function (o) { return __isa(o, "CORSConfiguration"); };
})(CORSConfiguration || (CORSConfiguration = {}));
export var CORSRule;
(function (CORSRule) {
    CORSRule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CORSRule.isa = function (o) { return __isa(o, "CORSRule"); };
})(CORSRule || (CORSRule = {}));
export var CreateBucketConfiguration;
(function (CreateBucketConfiguration) {
    CreateBucketConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateBucketConfiguration.isa = function (o) { return __isa(o, "CreateBucketConfiguration"); };
})(CreateBucketConfiguration || (CreateBucketConfiguration = {}));
export var CreateBucketOutput;
(function (CreateBucketOutput) {
    CreateBucketOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateBucketOutput.isa = function (o) { return __isa(o, "CreateBucketOutput"); };
})(CreateBucketOutput || (CreateBucketOutput = {}));
export var CreateBucketRequest;
(function (CreateBucketRequest) {
    CreateBucketRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateBucketRequest.isa = function (o) { return __isa(o, "CreateBucketRequest"); };
})(CreateBucketRequest || (CreateBucketRequest = {}));
export var CreateMultipartUploadOutput;
(function (CreateMultipartUploadOutput) {
    CreateMultipartUploadOutput.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING })), (obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING }))); };
    CreateMultipartUploadOutput.isa = function (o) { return __isa(o, "CreateMultipartUploadOutput"); };
})(CreateMultipartUploadOutput || (CreateMultipartUploadOutput = {}));
export var CreateMultipartUploadRequest;
(function (CreateMultipartUploadRequest) {
    CreateMultipartUploadRequest.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign(__assign({}, obj), (obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING })), (obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING })), (obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING }))); };
    CreateMultipartUploadRequest.isa = function (o) { return __isa(o, "CreateMultipartUploadRequest"); };
})(CreateMultipartUploadRequest || (CreateMultipartUploadRequest = {}));
export var CSVInput;
(function (CSVInput) {
    CSVInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CSVInput.isa = function (o) { return __isa(o, "CSVInput"); };
})(CSVInput || (CSVInput = {}));
export var CSVOutput;
(function (CSVOutput) {
    CSVOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CSVOutput.isa = function (o) { return __isa(o, "CSVOutput"); };
})(CSVOutput || (CSVOutput = {}));
export var DefaultRetention;
(function (DefaultRetention) {
    DefaultRetention.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DefaultRetention.isa = function (o) { return __isa(o, "DefaultRetention"); };
})(DefaultRetention || (DefaultRetention = {}));
export var Delete;
(function (Delete) {
    Delete.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Delete.isa = function (o) { return __isa(o, "Delete"); };
})(Delete || (Delete = {}));
export var DeleteBucketAnalyticsConfigurationRequest;
(function (DeleteBucketAnalyticsConfigurationRequest) {
    DeleteBucketAnalyticsConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteBucketAnalyticsConfigurationRequest.isa = function (o) {
        return __isa(o, "DeleteBucketAnalyticsConfigurationRequest");
    };
})(DeleteBucketAnalyticsConfigurationRequest || (DeleteBucketAnalyticsConfigurationRequest = {}));
export var DeleteBucketCorsRequest;
(function (DeleteBucketCorsRequest) {
    DeleteBucketCorsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteBucketCorsRequest.isa = function (o) { return __isa(o, "DeleteBucketCorsRequest"); };
})(DeleteBucketCorsRequest || (DeleteBucketCorsRequest = {}));
export var DeleteBucketEncryptionRequest;
(function (DeleteBucketEncryptionRequest) {
    DeleteBucketEncryptionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteBucketEncryptionRequest.isa = function (o) { return __isa(o, "DeleteBucketEncryptionRequest"); };
})(DeleteBucketEncryptionRequest || (DeleteBucketEncryptionRequest = {}));
export var DeleteBucketInventoryConfigurationRequest;
(function (DeleteBucketInventoryConfigurationRequest) {
    DeleteBucketInventoryConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteBucketInventoryConfigurationRequest.isa = function (o) {
        return __isa(o, "DeleteBucketInventoryConfigurationRequest");
    };
})(DeleteBucketInventoryConfigurationRequest || (DeleteBucketInventoryConfigurationRequest = {}));
export var DeleteBucketLifecycleRequest;
(function (DeleteBucketLifecycleRequest) {
    DeleteBucketLifecycleRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteBucketLifecycleRequest.isa = function (o) { return __isa(o, "DeleteBucketLifecycleRequest"); };
})(DeleteBucketLifecycleRequest || (DeleteBucketLifecycleRequest = {}));
export var DeleteBucketMetricsConfigurationRequest;
(function (DeleteBucketMetricsConfigurationRequest) {
    DeleteBucketMetricsConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteBucketMetricsConfigurationRequest.isa = function (o) {
        return __isa(o, "DeleteBucketMetricsConfigurationRequest");
    };
})(DeleteBucketMetricsConfigurationRequest || (DeleteBucketMetricsConfigurationRequest = {}));
export var DeleteBucketPolicyRequest;
(function (DeleteBucketPolicyRequest) {
    DeleteBucketPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteBucketPolicyRequest.isa = function (o) { return __isa(o, "DeleteBucketPolicyRequest"); };
})(DeleteBucketPolicyRequest || (DeleteBucketPolicyRequest = {}));
export var DeleteBucketReplicationRequest;
(function (DeleteBucketReplicationRequest) {
    DeleteBucketReplicationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteBucketReplicationRequest.isa = function (o) { return __isa(o, "DeleteBucketReplicationRequest"); };
})(DeleteBucketReplicationRequest || (DeleteBucketReplicationRequest = {}));
export var DeleteBucketRequest;
(function (DeleteBucketRequest) {
    DeleteBucketRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteBucketRequest.isa = function (o) { return __isa(o, "DeleteBucketRequest"); };
})(DeleteBucketRequest || (DeleteBucketRequest = {}));
export var DeleteBucketTaggingRequest;
(function (DeleteBucketTaggingRequest) {
    DeleteBucketTaggingRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteBucketTaggingRequest.isa = function (o) { return __isa(o, "DeleteBucketTaggingRequest"); };
})(DeleteBucketTaggingRequest || (DeleteBucketTaggingRequest = {}));
export var DeleteBucketWebsiteRequest;
(function (DeleteBucketWebsiteRequest) {
    DeleteBucketWebsiteRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteBucketWebsiteRequest.isa = function (o) { return __isa(o, "DeleteBucketWebsiteRequest"); };
})(DeleteBucketWebsiteRequest || (DeleteBucketWebsiteRequest = {}));
export var DeletedObject;
(function (DeletedObject) {
    DeletedObject.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeletedObject.isa = function (o) { return __isa(o, "DeletedObject"); };
})(DeletedObject || (DeletedObject = {}));
export var DeleteMarkerEntry;
(function (DeleteMarkerEntry) {
    DeleteMarkerEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteMarkerEntry.isa = function (o) { return __isa(o, "DeleteMarkerEntry"); };
})(DeleteMarkerEntry || (DeleteMarkerEntry = {}));
export var DeleteMarkerReplication;
(function (DeleteMarkerReplication) {
    DeleteMarkerReplication.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteMarkerReplication.isa = function (o) { return __isa(o, "DeleteMarkerReplication"); };
})(DeleteMarkerReplication || (DeleteMarkerReplication = {}));
export var DeleteObjectOutput;
(function (DeleteObjectOutput) {
    DeleteObjectOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteObjectOutput.isa = function (o) { return __isa(o, "DeleteObjectOutput"); };
})(DeleteObjectOutput || (DeleteObjectOutput = {}));
export var DeleteObjectRequest;
(function (DeleteObjectRequest) {
    DeleteObjectRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteObjectRequest.isa = function (o) { return __isa(o, "DeleteObjectRequest"); };
})(DeleteObjectRequest || (DeleteObjectRequest = {}));
export var DeleteObjectsOutput;
(function (DeleteObjectsOutput) {
    DeleteObjectsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteObjectsOutput.isa = function (o) { return __isa(o, "DeleteObjectsOutput"); };
})(DeleteObjectsOutput || (DeleteObjectsOutput = {}));
export var DeleteObjectsRequest;
(function (DeleteObjectsRequest) {
    DeleteObjectsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteObjectsRequest.isa = function (o) { return __isa(o, "DeleteObjectsRequest"); };
})(DeleteObjectsRequest || (DeleteObjectsRequest = {}));
export var DeleteObjectTaggingOutput;
(function (DeleteObjectTaggingOutput) {
    DeleteObjectTaggingOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteObjectTaggingOutput.isa = function (o) { return __isa(o, "DeleteObjectTaggingOutput"); };
})(DeleteObjectTaggingOutput || (DeleteObjectTaggingOutput = {}));
export var DeleteObjectTaggingRequest;
(function (DeleteObjectTaggingRequest) {
    DeleteObjectTaggingRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteObjectTaggingRequest.isa = function (o) { return __isa(o, "DeleteObjectTaggingRequest"); };
})(DeleteObjectTaggingRequest || (DeleteObjectTaggingRequest = {}));
export var DeletePublicAccessBlockRequest;
(function (DeletePublicAccessBlockRequest) {
    DeletePublicAccessBlockRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeletePublicAccessBlockRequest.isa = function (o) { return __isa(o, "DeletePublicAccessBlockRequest"); };
})(DeletePublicAccessBlockRequest || (DeletePublicAccessBlockRequest = {}));
export var Destination;
(function (Destination) {
    Destination.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Destination.isa = function (o) { return __isa(o, "Destination"); };
})(Destination || (Destination = {}));
export var Encryption;
(function (Encryption) {
    Encryption.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.KMSKeyId && { KMSKeyId: SENSITIVE_STRING }))); };
    Encryption.isa = function (o) { return __isa(o, "Encryption"); };
})(Encryption || (Encryption = {}));
export var EncryptionConfiguration;
(function (EncryptionConfiguration) {
    EncryptionConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EncryptionConfiguration.isa = function (o) { return __isa(o, "EncryptionConfiguration"); };
})(EncryptionConfiguration || (EncryptionConfiguration = {}));
export var EndEvent;
(function (EndEvent) {
    EndEvent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EndEvent.isa = function (o) { return __isa(o, "EndEvent"); };
})(EndEvent || (EndEvent = {}));
export var _Error;
(function (_Error) {
    _Error.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    _Error.isa = function (o) { return __isa(o, "Error"); };
})(_Error || (_Error = {}));
export var ErrorDocument;
(function (ErrorDocument) {
    ErrorDocument.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ErrorDocument.isa = function (o) { return __isa(o, "ErrorDocument"); };
})(ErrorDocument || (ErrorDocument = {}));
export var ExistingObjectReplication;
(function (ExistingObjectReplication) {
    ExistingObjectReplication.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ExistingObjectReplication.isa = function (o) { return __isa(o, "ExistingObjectReplication"); };
})(ExistingObjectReplication || (ExistingObjectReplication = {}));
export var FileHeaderInfo;
(function (FileHeaderInfo) {
    FileHeaderInfo["IGNORE"] = "IGNORE";
    FileHeaderInfo["NONE"] = "NONE";
    FileHeaderInfo["USE"] = "USE";
})(FileHeaderInfo || (FileHeaderInfo = {}));
export var FilterRule;
(function (FilterRule) {
    FilterRule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    FilterRule.isa = function (o) { return __isa(o, "FilterRule"); };
})(FilterRule || (FilterRule = {}));
export var GetBucketAccelerateConfigurationOutput;
(function (GetBucketAccelerateConfigurationOutput) {
    GetBucketAccelerateConfigurationOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketAccelerateConfigurationOutput.isa = function (o) {
        return __isa(o, "GetBucketAccelerateConfigurationOutput");
    };
})(GetBucketAccelerateConfigurationOutput || (GetBucketAccelerateConfigurationOutput = {}));
export var GetBucketAccelerateConfigurationRequest;
(function (GetBucketAccelerateConfigurationRequest) {
    GetBucketAccelerateConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketAccelerateConfigurationRequest.isa = function (o) {
        return __isa(o, "GetBucketAccelerateConfigurationRequest");
    };
})(GetBucketAccelerateConfigurationRequest || (GetBucketAccelerateConfigurationRequest = {}));
export var GetBucketAclOutput;
(function (GetBucketAclOutput) {
    GetBucketAclOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketAclOutput.isa = function (o) { return __isa(o, "GetBucketAclOutput"); };
})(GetBucketAclOutput || (GetBucketAclOutput = {}));
export var GetBucketAclRequest;
(function (GetBucketAclRequest) {
    GetBucketAclRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketAclRequest.isa = function (o) { return __isa(o, "GetBucketAclRequest"); };
})(GetBucketAclRequest || (GetBucketAclRequest = {}));
export var GetBucketAnalyticsConfigurationOutput;
(function (GetBucketAnalyticsConfigurationOutput) {
    GetBucketAnalyticsConfigurationOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketAnalyticsConfigurationOutput.isa = function (o) {
        return __isa(o, "GetBucketAnalyticsConfigurationOutput");
    };
})(GetBucketAnalyticsConfigurationOutput || (GetBucketAnalyticsConfigurationOutput = {}));
export var GetBucketAnalyticsConfigurationRequest;
(function (GetBucketAnalyticsConfigurationRequest) {
    GetBucketAnalyticsConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketAnalyticsConfigurationRequest.isa = function (o) {
        return __isa(o, "GetBucketAnalyticsConfigurationRequest");
    };
})(GetBucketAnalyticsConfigurationRequest || (GetBucketAnalyticsConfigurationRequest = {}));
export var GetBucketCorsOutput;
(function (GetBucketCorsOutput) {
    GetBucketCorsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketCorsOutput.isa = function (o) { return __isa(o, "GetBucketCorsOutput"); };
})(GetBucketCorsOutput || (GetBucketCorsOutput = {}));
export var GetBucketCorsRequest;
(function (GetBucketCorsRequest) {
    GetBucketCorsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketCorsRequest.isa = function (o) { return __isa(o, "GetBucketCorsRequest"); };
})(GetBucketCorsRequest || (GetBucketCorsRequest = {}));
export var GetBucketEncryptionOutput;
(function (GetBucketEncryptionOutput) {
    GetBucketEncryptionOutput.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ServerSideEncryptionConfiguration && {
        ServerSideEncryptionConfiguration: ServerSideEncryptionConfiguration.filterSensitiveLog(obj.ServerSideEncryptionConfiguration),
    }))); };
    GetBucketEncryptionOutput.isa = function (o) { return __isa(o, "GetBucketEncryptionOutput"); };
})(GetBucketEncryptionOutput || (GetBucketEncryptionOutput = {}));
export var GetBucketEncryptionRequest;
(function (GetBucketEncryptionRequest) {
    GetBucketEncryptionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketEncryptionRequest.isa = function (o) { return __isa(o, "GetBucketEncryptionRequest"); };
})(GetBucketEncryptionRequest || (GetBucketEncryptionRequest = {}));
export var GetBucketInventoryConfigurationOutput;
(function (GetBucketInventoryConfigurationOutput) {
    GetBucketInventoryConfigurationOutput.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.InventoryConfiguration && {
        InventoryConfiguration: InventoryConfiguration.filterSensitiveLog(obj.InventoryConfiguration),
    }))); };
    GetBucketInventoryConfigurationOutput.isa = function (o) {
        return __isa(o, "GetBucketInventoryConfigurationOutput");
    };
})(GetBucketInventoryConfigurationOutput || (GetBucketInventoryConfigurationOutput = {}));
export var GetBucketInventoryConfigurationRequest;
(function (GetBucketInventoryConfigurationRequest) {
    GetBucketInventoryConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketInventoryConfigurationRequest.isa = function (o) {
        return __isa(o, "GetBucketInventoryConfigurationRequest");
    };
})(GetBucketInventoryConfigurationRequest || (GetBucketInventoryConfigurationRequest = {}));
export var GetBucketLifecycleConfigurationOutput;
(function (GetBucketLifecycleConfigurationOutput) {
    GetBucketLifecycleConfigurationOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketLifecycleConfigurationOutput.isa = function (o) {
        return __isa(o, "GetBucketLifecycleConfigurationOutput");
    };
})(GetBucketLifecycleConfigurationOutput || (GetBucketLifecycleConfigurationOutput = {}));
export var GetBucketLifecycleConfigurationRequest;
(function (GetBucketLifecycleConfigurationRequest) {
    GetBucketLifecycleConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketLifecycleConfigurationRequest.isa = function (o) {
        return __isa(o, "GetBucketLifecycleConfigurationRequest");
    };
})(GetBucketLifecycleConfigurationRequest || (GetBucketLifecycleConfigurationRequest = {}));
export var GetBucketLocationOutput;
(function (GetBucketLocationOutput) {
    GetBucketLocationOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketLocationOutput.isa = function (o) { return __isa(o, "GetBucketLocationOutput"); };
})(GetBucketLocationOutput || (GetBucketLocationOutput = {}));
export var GetBucketLocationRequest;
(function (GetBucketLocationRequest) {
    GetBucketLocationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketLocationRequest.isa = function (o) { return __isa(o, "GetBucketLocationRequest"); };
})(GetBucketLocationRequest || (GetBucketLocationRequest = {}));
export var GetBucketLoggingOutput;
(function (GetBucketLoggingOutput) {
    GetBucketLoggingOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketLoggingOutput.isa = function (o) { return __isa(o, "GetBucketLoggingOutput"); };
})(GetBucketLoggingOutput || (GetBucketLoggingOutput = {}));
export var GetBucketLoggingRequest;
(function (GetBucketLoggingRequest) {
    GetBucketLoggingRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketLoggingRequest.isa = function (o) { return __isa(o, "GetBucketLoggingRequest"); };
})(GetBucketLoggingRequest || (GetBucketLoggingRequest = {}));
export var GetBucketMetricsConfigurationOutput;
(function (GetBucketMetricsConfigurationOutput) {
    GetBucketMetricsConfigurationOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketMetricsConfigurationOutput.isa = function (o) {
        return __isa(o, "GetBucketMetricsConfigurationOutput");
    };
})(GetBucketMetricsConfigurationOutput || (GetBucketMetricsConfigurationOutput = {}));
export var GetBucketMetricsConfigurationRequest;
(function (GetBucketMetricsConfigurationRequest) {
    GetBucketMetricsConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketMetricsConfigurationRequest.isa = function (o) {
        return __isa(o, "GetBucketMetricsConfigurationRequest");
    };
})(GetBucketMetricsConfigurationRequest || (GetBucketMetricsConfigurationRequest = {}));
export var GetBucketNotificationConfigurationRequest;
(function (GetBucketNotificationConfigurationRequest) {
    GetBucketNotificationConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketNotificationConfigurationRequest.isa = function (o) {
        return __isa(o, "GetBucketNotificationConfigurationRequest");
    };
})(GetBucketNotificationConfigurationRequest || (GetBucketNotificationConfigurationRequest = {}));
export var GetBucketPolicyOutput;
(function (GetBucketPolicyOutput) {
    GetBucketPolicyOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketPolicyOutput.isa = function (o) { return __isa(o, "GetBucketPolicyOutput"); };
})(GetBucketPolicyOutput || (GetBucketPolicyOutput = {}));
export var GetBucketPolicyRequest;
(function (GetBucketPolicyRequest) {
    GetBucketPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketPolicyRequest.isa = function (o) { return __isa(o, "GetBucketPolicyRequest"); };
})(GetBucketPolicyRequest || (GetBucketPolicyRequest = {}));
export var GetBucketPolicyStatusOutput;
(function (GetBucketPolicyStatusOutput) {
    GetBucketPolicyStatusOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketPolicyStatusOutput.isa = function (o) { return __isa(o, "GetBucketPolicyStatusOutput"); };
})(GetBucketPolicyStatusOutput || (GetBucketPolicyStatusOutput = {}));
export var GetBucketPolicyStatusRequest;
(function (GetBucketPolicyStatusRequest) {
    GetBucketPolicyStatusRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketPolicyStatusRequest.isa = function (o) { return __isa(o, "GetBucketPolicyStatusRequest"); };
})(GetBucketPolicyStatusRequest || (GetBucketPolicyStatusRequest = {}));
export var GetBucketReplicationOutput;
(function (GetBucketReplicationOutput) {
    GetBucketReplicationOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketReplicationOutput.isa = function (o) { return __isa(o, "GetBucketReplicationOutput"); };
})(GetBucketReplicationOutput || (GetBucketReplicationOutput = {}));
export var GetBucketReplicationRequest;
(function (GetBucketReplicationRequest) {
    GetBucketReplicationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketReplicationRequest.isa = function (o) { return __isa(o, "GetBucketReplicationRequest"); };
})(GetBucketReplicationRequest || (GetBucketReplicationRequest = {}));
export var GetBucketRequestPaymentOutput;
(function (GetBucketRequestPaymentOutput) {
    GetBucketRequestPaymentOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketRequestPaymentOutput.isa = function (o) { return __isa(o, "GetBucketRequestPaymentOutput"); };
})(GetBucketRequestPaymentOutput || (GetBucketRequestPaymentOutput = {}));
export var GetBucketRequestPaymentRequest;
(function (GetBucketRequestPaymentRequest) {
    GetBucketRequestPaymentRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketRequestPaymentRequest.isa = function (o) { return __isa(o, "GetBucketRequestPaymentRequest"); };
})(GetBucketRequestPaymentRequest || (GetBucketRequestPaymentRequest = {}));
export var GetBucketTaggingOutput;
(function (GetBucketTaggingOutput) {
    GetBucketTaggingOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketTaggingOutput.isa = function (o) { return __isa(o, "GetBucketTaggingOutput"); };
})(GetBucketTaggingOutput || (GetBucketTaggingOutput = {}));
export var GetBucketTaggingRequest;
(function (GetBucketTaggingRequest) {
    GetBucketTaggingRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketTaggingRequest.isa = function (o) { return __isa(o, "GetBucketTaggingRequest"); };
})(GetBucketTaggingRequest || (GetBucketTaggingRequest = {}));
export var GetBucketVersioningOutput;
(function (GetBucketVersioningOutput) {
    GetBucketVersioningOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketVersioningOutput.isa = function (o) { return __isa(o, "GetBucketVersioningOutput"); };
})(GetBucketVersioningOutput || (GetBucketVersioningOutput = {}));
export var GetBucketVersioningRequest;
(function (GetBucketVersioningRequest) {
    GetBucketVersioningRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketVersioningRequest.isa = function (o) { return __isa(o, "GetBucketVersioningRequest"); };
})(GetBucketVersioningRequest || (GetBucketVersioningRequest = {}));
export var GetBucketWebsiteOutput;
(function (GetBucketWebsiteOutput) {
    GetBucketWebsiteOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketWebsiteOutput.isa = function (o) { return __isa(o, "GetBucketWebsiteOutput"); };
})(GetBucketWebsiteOutput || (GetBucketWebsiteOutput = {}));
export var GetBucketWebsiteRequest;
(function (GetBucketWebsiteRequest) {
    GetBucketWebsiteRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBucketWebsiteRequest.isa = function (o) { return __isa(o, "GetBucketWebsiteRequest"); };
})(GetBucketWebsiteRequest || (GetBucketWebsiteRequest = {}));
export var GetObjectAclOutput;
(function (GetObjectAclOutput) {
    GetObjectAclOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetObjectAclOutput.isa = function (o) { return __isa(o, "GetObjectAclOutput"); };
})(GetObjectAclOutput || (GetObjectAclOutput = {}));
export var GetObjectAclRequest;
(function (GetObjectAclRequest) {
    GetObjectAclRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetObjectAclRequest.isa = function (o) { return __isa(o, "GetObjectAclRequest"); };
})(GetObjectAclRequest || (GetObjectAclRequest = {}));
export var GetObjectLegalHoldOutput;
(function (GetObjectLegalHoldOutput) {
    GetObjectLegalHoldOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetObjectLegalHoldOutput.isa = function (o) { return __isa(o, "GetObjectLegalHoldOutput"); };
})(GetObjectLegalHoldOutput || (GetObjectLegalHoldOutput = {}));
export var GetObjectLegalHoldRequest;
(function (GetObjectLegalHoldRequest) {
    GetObjectLegalHoldRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetObjectLegalHoldRequest.isa = function (o) { return __isa(o, "GetObjectLegalHoldRequest"); };
})(GetObjectLegalHoldRequest || (GetObjectLegalHoldRequest = {}));
export var GetObjectLockConfigurationOutput;
(function (GetObjectLockConfigurationOutput) {
    GetObjectLockConfigurationOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetObjectLockConfigurationOutput.isa = function (o) { return __isa(o, "GetObjectLockConfigurationOutput"); };
})(GetObjectLockConfigurationOutput || (GetObjectLockConfigurationOutput = {}));
export var GetObjectLockConfigurationRequest;
(function (GetObjectLockConfigurationRequest) {
    GetObjectLockConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetObjectLockConfigurationRequest.isa = function (o) { return __isa(o, "GetObjectLockConfigurationRequest"); };
})(GetObjectLockConfigurationRequest || (GetObjectLockConfigurationRequest = {}));
export var GetObjectOutput;
(function (GetObjectOutput) {
    GetObjectOutput.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING }))); };
    GetObjectOutput.isa = function (o) { return __isa(o, "GetObjectOutput"); };
})(GetObjectOutput || (GetObjectOutput = {}));
export var GetObjectRequest;
(function (GetObjectRequest) {
    GetObjectRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING }))); };
    GetObjectRequest.isa = function (o) { return __isa(o, "GetObjectRequest"); };
})(GetObjectRequest || (GetObjectRequest = {}));
export var GetObjectRetentionOutput;
(function (GetObjectRetentionOutput) {
    GetObjectRetentionOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetObjectRetentionOutput.isa = function (o) { return __isa(o, "GetObjectRetentionOutput"); };
})(GetObjectRetentionOutput || (GetObjectRetentionOutput = {}));
export var GetObjectRetentionRequest;
(function (GetObjectRetentionRequest) {
    GetObjectRetentionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetObjectRetentionRequest.isa = function (o) { return __isa(o, "GetObjectRetentionRequest"); };
})(GetObjectRetentionRequest || (GetObjectRetentionRequest = {}));
export var GetObjectTaggingOutput;
(function (GetObjectTaggingOutput) {
    GetObjectTaggingOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetObjectTaggingOutput.isa = function (o) { return __isa(o, "GetObjectTaggingOutput"); };
})(GetObjectTaggingOutput || (GetObjectTaggingOutput = {}));
export var GetObjectTaggingRequest;
(function (GetObjectTaggingRequest) {
    GetObjectTaggingRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetObjectTaggingRequest.isa = function (o) { return __isa(o, "GetObjectTaggingRequest"); };
})(GetObjectTaggingRequest || (GetObjectTaggingRequest = {}));
export var GetObjectTorrentOutput;
(function (GetObjectTorrentOutput) {
    GetObjectTorrentOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetObjectTorrentOutput.isa = function (o) { return __isa(o, "GetObjectTorrentOutput"); };
})(GetObjectTorrentOutput || (GetObjectTorrentOutput = {}));
export var GetObjectTorrentRequest;
(function (GetObjectTorrentRequest) {
    GetObjectTorrentRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetObjectTorrentRequest.isa = function (o) { return __isa(o, "GetObjectTorrentRequest"); };
})(GetObjectTorrentRequest || (GetObjectTorrentRequest = {}));
export var GetPublicAccessBlockOutput;
(function (GetPublicAccessBlockOutput) {
    GetPublicAccessBlockOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetPublicAccessBlockOutput.isa = function (o) { return __isa(o, "GetPublicAccessBlockOutput"); };
})(GetPublicAccessBlockOutput || (GetPublicAccessBlockOutput = {}));
export var GetPublicAccessBlockRequest;
(function (GetPublicAccessBlockRequest) {
    GetPublicAccessBlockRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetPublicAccessBlockRequest.isa = function (o) { return __isa(o, "GetPublicAccessBlockRequest"); };
})(GetPublicAccessBlockRequest || (GetPublicAccessBlockRequest = {}));
export var GlacierJobParameters;
(function (GlacierJobParameters) {
    GlacierJobParameters.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GlacierJobParameters.isa = function (o) { return __isa(o, "GlacierJobParameters"); };
})(GlacierJobParameters || (GlacierJobParameters = {}));
export var Grant;
(function (Grant) {
    Grant.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Grant.isa = function (o) { return __isa(o, "Grant"); };
})(Grant || (Grant = {}));
export var Grantee;
(function (Grantee) {
    Grantee.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Grantee.isa = function (o) { return __isa(o, "Grantee"); };
})(Grantee || (Grantee = {}));
export var HeadBucketRequest;
(function (HeadBucketRequest) {
    HeadBucketRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    HeadBucketRequest.isa = function (o) { return __isa(o, "HeadBucketRequest"); };
})(HeadBucketRequest || (HeadBucketRequest = {}));
export var HeadObjectOutput;
(function (HeadObjectOutput) {
    HeadObjectOutput.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING }))); };
    HeadObjectOutput.isa = function (o) { return __isa(o, "HeadObjectOutput"); };
})(HeadObjectOutput || (HeadObjectOutput = {}));
export var HeadObjectRequest;
(function (HeadObjectRequest) {
    HeadObjectRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING }))); };
    HeadObjectRequest.isa = function (o) { return __isa(o, "HeadObjectRequest"); };
})(HeadObjectRequest || (HeadObjectRequest = {}));
export var IndexDocument;
(function (IndexDocument) {
    IndexDocument.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    IndexDocument.isa = function (o) { return __isa(o, "IndexDocument"); };
})(IndexDocument || (IndexDocument = {}));
export var Initiator;
(function (Initiator) {
    Initiator.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Initiator.isa = function (o) { return __isa(o, "Initiator"); };
})(Initiator || (Initiator = {}));
export var InputSerialization;
(function (InputSerialization) {
    InputSerialization.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InputSerialization.isa = function (o) { return __isa(o, "InputSerialization"); };
})(InputSerialization || (InputSerialization = {}));
export var InventoryConfiguration;
(function (InventoryConfiguration) {
    InventoryConfiguration.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Destination && { Destination: InventoryDestination.filterSensitiveLog(obj.Destination) }))); };
    InventoryConfiguration.isa = function (o) { return __isa(o, "InventoryConfiguration"); };
})(InventoryConfiguration || (InventoryConfiguration = {}));
export var InventoryDestination;
(function (InventoryDestination) {
    InventoryDestination.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.S3BucketDestination && {
        S3BucketDestination: InventoryS3BucketDestination.filterSensitiveLog(obj.S3BucketDestination),
    }))); };
    InventoryDestination.isa = function (o) { return __isa(o, "InventoryDestination"); };
})(InventoryDestination || (InventoryDestination = {}));
export var InventoryEncryption;
(function (InventoryEncryption) {
    InventoryEncryption.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.SSEKMS && { SSEKMS: SSEKMS.filterSensitiveLog(obj.SSEKMS) }))); };
    InventoryEncryption.isa = function (o) { return __isa(o, "InventoryEncryption"); };
})(InventoryEncryption || (InventoryEncryption = {}));
export var InventoryFilter;
(function (InventoryFilter) {
    InventoryFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InventoryFilter.isa = function (o) { return __isa(o, "InventoryFilter"); };
})(InventoryFilter || (InventoryFilter = {}));
export var InventoryS3BucketDestination;
(function (InventoryS3BucketDestination) {
    InventoryS3BucketDestination.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Encryption && { Encryption: InventoryEncryption.filterSensitiveLog(obj.Encryption) }))); };
    InventoryS3BucketDestination.isa = function (o) { return __isa(o, "InventoryS3BucketDestination"); };
})(InventoryS3BucketDestination || (InventoryS3BucketDestination = {}));
export var InventorySchedule;
(function (InventorySchedule) {
    InventorySchedule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InventorySchedule.isa = function (o) { return __isa(o, "InventorySchedule"); };
})(InventorySchedule || (InventorySchedule = {}));
export var JSONInput;
(function (JSONInput) {
    JSONInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JSONInput.isa = function (o) { return __isa(o, "JSONInput"); };
})(JSONInput || (JSONInput = {}));
export var JSONOutput;
(function (JSONOutput) {
    JSONOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JSONOutput.isa = function (o) { return __isa(o, "JSONOutput"); };
})(JSONOutput || (JSONOutput = {}));
export var JSONType;
(function (JSONType) {
    JSONType["DOCUMENT"] = "DOCUMENT";
    JSONType["LINES"] = "LINES";
})(JSONType || (JSONType = {}));
export var LambdaFunctionConfiguration;
(function (LambdaFunctionConfiguration) {
    LambdaFunctionConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    LambdaFunctionConfiguration.isa = function (o) { return __isa(o, "LambdaFunctionConfiguration"); };
})(LambdaFunctionConfiguration || (LambdaFunctionConfiguration = {}));
export var LifecycleExpiration;
(function (LifecycleExpiration) {
    LifecycleExpiration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    LifecycleExpiration.isa = function (o) { return __isa(o, "LifecycleExpiration"); };
})(LifecycleExpiration || (LifecycleExpiration = {}));
export var LifecycleRule;
(function (LifecycleRule) {
    LifecycleRule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    LifecycleRule.isa = function (o) { return __isa(o, "LifecycleRule"); };
})(LifecycleRule || (LifecycleRule = {}));
export var LifecycleRuleAndOperator;
(function (LifecycleRuleAndOperator) {
    LifecycleRuleAndOperator.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    LifecycleRuleAndOperator.isa = function (o) { return __isa(o, "LifecycleRuleAndOperator"); };
})(LifecycleRuleAndOperator || (LifecycleRuleAndOperator = {}));
export var LifecycleRuleFilter;
(function (LifecycleRuleFilter) {
    LifecycleRuleFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    LifecycleRuleFilter.isa = function (o) { return __isa(o, "LifecycleRuleFilter"); };
})(LifecycleRuleFilter || (LifecycleRuleFilter = {}));
export var ListBucketAnalyticsConfigurationsOutput;
(function (ListBucketAnalyticsConfigurationsOutput) {
    ListBucketAnalyticsConfigurationsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListBucketAnalyticsConfigurationsOutput.isa = function (o) {
        return __isa(o, "ListBucketAnalyticsConfigurationsOutput");
    };
})(ListBucketAnalyticsConfigurationsOutput || (ListBucketAnalyticsConfigurationsOutput = {}));
export var ListBucketAnalyticsConfigurationsRequest;
(function (ListBucketAnalyticsConfigurationsRequest) {
    ListBucketAnalyticsConfigurationsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListBucketAnalyticsConfigurationsRequest.isa = function (o) {
        return __isa(o, "ListBucketAnalyticsConfigurationsRequest");
    };
})(ListBucketAnalyticsConfigurationsRequest || (ListBucketAnalyticsConfigurationsRequest = {}));
export var ListBucketInventoryConfigurationsOutput;
(function (ListBucketInventoryConfigurationsOutput) {
    ListBucketInventoryConfigurationsOutput.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.InventoryConfigurationList && {
        InventoryConfigurationList: obj.InventoryConfigurationList.map(function (item) {
            return InventoryConfiguration.filterSensitiveLog(item);
        }),
    }))); };
    ListBucketInventoryConfigurationsOutput.isa = function (o) {
        return __isa(o, "ListBucketInventoryConfigurationsOutput");
    };
})(ListBucketInventoryConfigurationsOutput || (ListBucketInventoryConfigurationsOutput = {}));
export var ListBucketInventoryConfigurationsRequest;
(function (ListBucketInventoryConfigurationsRequest) {
    ListBucketInventoryConfigurationsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListBucketInventoryConfigurationsRequest.isa = function (o) {
        return __isa(o, "ListBucketInventoryConfigurationsRequest");
    };
})(ListBucketInventoryConfigurationsRequest || (ListBucketInventoryConfigurationsRequest = {}));
export var ListBucketMetricsConfigurationsOutput;
(function (ListBucketMetricsConfigurationsOutput) {
    ListBucketMetricsConfigurationsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListBucketMetricsConfigurationsOutput.isa = function (o) {
        return __isa(o, "ListBucketMetricsConfigurationsOutput");
    };
})(ListBucketMetricsConfigurationsOutput || (ListBucketMetricsConfigurationsOutput = {}));
export var ListBucketMetricsConfigurationsRequest;
(function (ListBucketMetricsConfigurationsRequest) {
    ListBucketMetricsConfigurationsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListBucketMetricsConfigurationsRequest.isa = function (o) {
        return __isa(o, "ListBucketMetricsConfigurationsRequest");
    };
})(ListBucketMetricsConfigurationsRequest || (ListBucketMetricsConfigurationsRequest = {}));
export var ListBucketsOutput;
(function (ListBucketsOutput) {
    ListBucketsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListBucketsOutput.isa = function (o) { return __isa(o, "ListBucketsOutput"); };
})(ListBucketsOutput || (ListBucketsOutput = {}));
export var ListMultipartUploadsOutput;
(function (ListMultipartUploadsOutput) {
    ListMultipartUploadsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListMultipartUploadsOutput.isa = function (o) { return __isa(o, "ListMultipartUploadsOutput"); };
})(ListMultipartUploadsOutput || (ListMultipartUploadsOutput = {}));
export var ListMultipartUploadsRequest;
(function (ListMultipartUploadsRequest) {
    ListMultipartUploadsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListMultipartUploadsRequest.isa = function (o) { return __isa(o, "ListMultipartUploadsRequest"); };
})(ListMultipartUploadsRequest || (ListMultipartUploadsRequest = {}));
export var ListObjectsOutput;
(function (ListObjectsOutput) {
    ListObjectsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListObjectsOutput.isa = function (o) { return __isa(o, "ListObjectsOutput"); };
})(ListObjectsOutput || (ListObjectsOutput = {}));
export var ListObjectsRequest;
(function (ListObjectsRequest) {
    ListObjectsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListObjectsRequest.isa = function (o) { return __isa(o, "ListObjectsRequest"); };
})(ListObjectsRequest || (ListObjectsRequest = {}));
export var ListObjectsV2Output;
(function (ListObjectsV2Output) {
    ListObjectsV2Output.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListObjectsV2Output.isa = function (o) { return __isa(o, "ListObjectsV2Output"); };
})(ListObjectsV2Output || (ListObjectsV2Output = {}));
export var ListObjectsV2Request;
(function (ListObjectsV2Request) {
    ListObjectsV2Request.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListObjectsV2Request.isa = function (o) { return __isa(o, "ListObjectsV2Request"); };
})(ListObjectsV2Request || (ListObjectsV2Request = {}));
export var ListObjectVersionsOutput;
(function (ListObjectVersionsOutput) {
    ListObjectVersionsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListObjectVersionsOutput.isa = function (o) { return __isa(o, "ListObjectVersionsOutput"); };
})(ListObjectVersionsOutput || (ListObjectVersionsOutput = {}));
export var ListObjectVersionsRequest;
(function (ListObjectVersionsRequest) {
    ListObjectVersionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListObjectVersionsRequest.isa = function (o) { return __isa(o, "ListObjectVersionsRequest"); };
})(ListObjectVersionsRequest || (ListObjectVersionsRequest = {}));
export var ListPartsOutput;
(function (ListPartsOutput) {
    ListPartsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListPartsOutput.isa = function (o) { return __isa(o, "ListPartsOutput"); };
})(ListPartsOutput || (ListPartsOutput = {}));
export var ListPartsRequest;
(function (ListPartsRequest) {
    ListPartsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListPartsRequest.isa = function (o) { return __isa(o, "ListPartsRequest"); };
})(ListPartsRequest || (ListPartsRequest = {}));
export var LoggingEnabled;
(function (LoggingEnabled) {
    LoggingEnabled.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    LoggingEnabled.isa = function (o) { return __isa(o, "LoggingEnabled"); };
})(LoggingEnabled || (LoggingEnabled = {}));
export var MetadataEntry;
(function (MetadataEntry) {
    MetadataEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MetadataEntry.isa = function (o) { return __isa(o, "MetadataEntry"); };
})(MetadataEntry || (MetadataEntry = {}));
export var Metrics;
(function (Metrics) {
    Metrics.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Metrics.isa = function (o) { return __isa(o, "Metrics"); };
})(Metrics || (Metrics = {}));
export var MetricsAndOperator;
(function (MetricsAndOperator) {
    MetricsAndOperator.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MetricsAndOperator.isa = function (o) { return __isa(o, "MetricsAndOperator"); };
})(MetricsAndOperator || (MetricsAndOperator = {}));
export var MetricsConfiguration;
(function (MetricsConfiguration) {
    MetricsConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MetricsConfiguration.isa = function (o) { return __isa(o, "MetricsConfiguration"); };
})(MetricsConfiguration || (MetricsConfiguration = {}));
export var MetricsFilter;
(function (MetricsFilter) {
    MetricsFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MetricsFilter.isa = function (o) { return __isa(o, "MetricsFilter"); };
})(MetricsFilter || (MetricsFilter = {}));
export var MultipartUpload;
(function (MultipartUpload) {
    MultipartUpload.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MultipartUpload.isa = function (o) { return __isa(o, "MultipartUpload"); };
})(MultipartUpload || (MultipartUpload = {}));
export var NoncurrentVersionExpiration;
(function (NoncurrentVersionExpiration) {
    NoncurrentVersionExpiration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    NoncurrentVersionExpiration.isa = function (o) { return __isa(o, "NoncurrentVersionExpiration"); };
})(NoncurrentVersionExpiration || (NoncurrentVersionExpiration = {}));
export var NoncurrentVersionTransition;
(function (NoncurrentVersionTransition) {
    NoncurrentVersionTransition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    NoncurrentVersionTransition.isa = function (o) { return __isa(o, "NoncurrentVersionTransition"); };
})(NoncurrentVersionTransition || (NoncurrentVersionTransition = {}));
export var NoSuchBucket;
(function (NoSuchBucket) {
    NoSuchBucket.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    NoSuchBucket.isa = function (o) { return __isa(o, "NoSuchBucket"); };
})(NoSuchBucket || (NoSuchBucket = {}));
export var NoSuchKey;
(function (NoSuchKey) {
    NoSuchKey.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    NoSuchKey.isa = function (o) { return __isa(o, "NoSuchKey"); };
})(NoSuchKey || (NoSuchKey = {}));
export var NoSuchUpload;
(function (NoSuchUpload) {
    NoSuchUpload.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    NoSuchUpload.isa = function (o) { return __isa(o, "NoSuchUpload"); };
})(NoSuchUpload || (NoSuchUpload = {}));
export var NotificationConfiguration;
(function (NotificationConfiguration) {
    NotificationConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    NotificationConfiguration.isa = function (o) { return __isa(o, "NotificationConfiguration"); };
})(NotificationConfiguration || (NotificationConfiguration = {}));
export var NotificationConfigurationFilter;
(function (NotificationConfigurationFilter) {
    NotificationConfigurationFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    NotificationConfigurationFilter.isa = function (o) { return __isa(o, "NotificationConfigurationFilter"); };
})(NotificationConfigurationFilter || (NotificationConfigurationFilter = {}));
export var _Object;
(function (_Object) {
    _Object.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    _Object.isa = function (o) { return __isa(o, "Object"); };
})(_Object || (_Object = {}));
export var ObjectAlreadyInActiveTierError;
(function (ObjectAlreadyInActiveTierError) {
    ObjectAlreadyInActiveTierError.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ObjectAlreadyInActiveTierError.isa = function (o) { return __isa(o, "ObjectAlreadyInActiveTierError"); };
})(ObjectAlreadyInActiveTierError || (ObjectAlreadyInActiveTierError = {}));
export var ObjectIdentifier;
(function (ObjectIdentifier) {
    ObjectIdentifier.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ObjectIdentifier.isa = function (o) { return __isa(o, "ObjectIdentifier"); };
})(ObjectIdentifier || (ObjectIdentifier = {}));
export var ObjectLockConfiguration;
(function (ObjectLockConfiguration) {
    ObjectLockConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ObjectLockConfiguration.isa = function (o) { return __isa(o, "ObjectLockConfiguration"); };
})(ObjectLockConfiguration || (ObjectLockConfiguration = {}));
export var ObjectLockLegalHold;
(function (ObjectLockLegalHold) {
    ObjectLockLegalHold.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ObjectLockLegalHold.isa = function (o) { return __isa(o, "ObjectLockLegalHold"); };
})(ObjectLockLegalHold || (ObjectLockLegalHold = {}));
export var ObjectLockRetention;
(function (ObjectLockRetention) {
    ObjectLockRetention.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ObjectLockRetention.isa = function (o) { return __isa(o, "ObjectLockRetention"); };
})(ObjectLockRetention || (ObjectLockRetention = {}));
export var ObjectLockRule;
(function (ObjectLockRule) {
    ObjectLockRule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ObjectLockRule.isa = function (o) { return __isa(o, "ObjectLockRule"); };
})(ObjectLockRule || (ObjectLockRule = {}));
export var ObjectNotInActiveTierError;
(function (ObjectNotInActiveTierError) {
    ObjectNotInActiveTierError.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ObjectNotInActiveTierError.isa = function (o) { return __isa(o, "ObjectNotInActiveTierError"); };
})(ObjectNotInActiveTierError || (ObjectNotInActiveTierError = {}));
export var ObjectVersion;
(function (ObjectVersion) {
    ObjectVersion.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ObjectVersion.isa = function (o) { return __isa(o, "ObjectVersion"); };
})(ObjectVersion || (ObjectVersion = {}));
export var OutputLocation;
(function (OutputLocation) {
    OutputLocation.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.S3 && { S3: S3Location.filterSensitiveLog(obj.S3) }))); };
    OutputLocation.isa = function (o) { return __isa(o, "OutputLocation"); };
})(OutputLocation || (OutputLocation = {}));
export var OutputSerialization;
(function (OutputSerialization) {
    OutputSerialization.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    OutputSerialization.isa = function (o) { return __isa(o, "OutputSerialization"); };
})(OutputSerialization || (OutputSerialization = {}));
export var Owner;
(function (Owner) {
    Owner.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Owner.isa = function (o) { return __isa(o, "Owner"); };
})(Owner || (Owner = {}));
export var ParquetInput;
(function (ParquetInput) {
    ParquetInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ParquetInput.isa = function (o) { return __isa(o, "ParquetInput"); };
})(ParquetInput || (ParquetInput = {}));
export var Part;
(function (Part) {
    Part.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Part.isa = function (o) { return __isa(o, "Part"); };
})(Part || (Part = {}));
export var PolicyStatus;
(function (PolicyStatus) {
    PolicyStatus.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PolicyStatus.isa = function (o) { return __isa(o, "PolicyStatus"); };
})(PolicyStatus || (PolicyStatus = {}));
export var Progress;
(function (Progress) {
    Progress.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Progress.isa = function (o) { return __isa(o, "Progress"); };
})(Progress || (Progress = {}));
export var ProgressEvent;
(function (ProgressEvent) {
    ProgressEvent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ProgressEvent.isa = function (o) { return __isa(o, "ProgressEvent"); };
})(ProgressEvent || (ProgressEvent = {}));
export var PublicAccessBlockConfiguration;
(function (PublicAccessBlockConfiguration) {
    PublicAccessBlockConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PublicAccessBlockConfiguration.isa = function (o) { return __isa(o, "PublicAccessBlockConfiguration"); };
})(PublicAccessBlockConfiguration || (PublicAccessBlockConfiguration = {}));
export var PutBucketAccelerateConfigurationRequest;
(function (PutBucketAccelerateConfigurationRequest) {
    PutBucketAccelerateConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketAccelerateConfigurationRequest.isa = function (o) {
        return __isa(o, "PutBucketAccelerateConfigurationRequest");
    };
})(PutBucketAccelerateConfigurationRequest || (PutBucketAccelerateConfigurationRequest = {}));
export var PutBucketAclRequest;
(function (PutBucketAclRequest) {
    PutBucketAclRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketAclRequest.isa = function (o) { return __isa(o, "PutBucketAclRequest"); };
})(PutBucketAclRequest || (PutBucketAclRequest = {}));
export var PutBucketAnalyticsConfigurationRequest;
(function (PutBucketAnalyticsConfigurationRequest) {
    PutBucketAnalyticsConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketAnalyticsConfigurationRequest.isa = function (o) {
        return __isa(o, "PutBucketAnalyticsConfigurationRequest");
    };
})(PutBucketAnalyticsConfigurationRequest || (PutBucketAnalyticsConfigurationRequest = {}));
export var PutBucketCorsRequest;
(function (PutBucketCorsRequest) {
    PutBucketCorsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketCorsRequest.isa = function (o) { return __isa(o, "PutBucketCorsRequest"); };
})(PutBucketCorsRequest || (PutBucketCorsRequest = {}));
export var PutBucketEncryptionRequest;
(function (PutBucketEncryptionRequest) {
    PutBucketEncryptionRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ServerSideEncryptionConfiguration && {
        ServerSideEncryptionConfiguration: ServerSideEncryptionConfiguration.filterSensitiveLog(obj.ServerSideEncryptionConfiguration),
    }))); };
    PutBucketEncryptionRequest.isa = function (o) { return __isa(o, "PutBucketEncryptionRequest"); };
})(PutBucketEncryptionRequest || (PutBucketEncryptionRequest = {}));
export var PutBucketInventoryConfigurationRequest;
(function (PutBucketInventoryConfigurationRequest) {
    PutBucketInventoryConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.InventoryConfiguration && {
        InventoryConfiguration: InventoryConfiguration.filterSensitiveLog(obj.InventoryConfiguration),
    }))); };
    PutBucketInventoryConfigurationRequest.isa = function (o) {
        return __isa(o, "PutBucketInventoryConfigurationRequest");
    };
})(PutBucketInventoryConfigurationRequest || (PutBucketInventoryConfigurationRequest = {}));
export var PutBucketLifecycleConfigurationRequest;
(function (PutBucketLifecycleConfigurationRequest) {
    PutBucketLifecycleConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketLifecycleConfigurationRequest.isa = function (o) {
        return __isa(o, "PutBucketLifecycleConfigurationRequest");
    };
})(PutBucketLifecycleConfigurationRequest || (PutBucketLifecycleConfigurationRequest = {}));
export var PutBucketLoggingRequest;
(function (PutBucketLoggingRequest) {
    PutBucketLoggingRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketLoggingRequest.isa = function (o) { return __isa(o, "PutBucketLoggingRequest"); };
})(PutBucketLoggingRequest || (PutBucketLoggingRequest = {}));
export var PutBucketMetricsConfigurationRequest;
(function (PutBucketMetricsConfigurationRequest) {
    PutBucketMetricsConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketMetricsConfigurationRequest.isa = function (o) {
        return __isa(o, "PutBucketMetricsConfigurationRequest");
    };
})(PutBucketMetricsConfigurationRequest || (PutBucketMetricsConfigurationRequest = {}));
export var PutBucketNotificationConfigurationRequest;
(function (PutBucketNotificationConfigurationRequest) {
    PutBucketNotificationConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketNotificationConfigurationRequest.isa = function (o) {
        return __isa(o, "PutBucketNotificationConfigurationRequest");
    };
})(PutBucketNotificationConfigurationRequest || (PutBucketNotificationConfigurationRequest = {}));
export var PutBucketPolicyRequest;
(function (PutBucketPolicyRequest) {
    PutBucketPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketPolicyRequest.isa = function (o) { return __isa(o, "PutBucketPolicyRequest"); };
})(PutBucketPolicyRequest || (PutBucketPolicyRequest = {}));
export var PutBucketReplicationRequest;
(function (PutBucketReplicationRequest) {
    PutBucketReplicationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketReplicationRequest.isa = function (o) { return __isa(o, "PutBucketReplicationRequest"); };
})(PutBucketReplicationRequest || (PutBucketReplicationRequest = {}));
export var PutBucketRequestPaymentRequest;
(function (PutBucketRequestPaymentRequest) {
    PutBucketRequestPaymentRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketRequestPaymentRequest.isa = function (o) { return __isa(o, "PutBucketRequestPaymentRequest"); };
})(PutBucketRequestPaymentRequest || (PutBucketRequestPaymentRequest = {}));
export var PutBucketTaggingRequest;
(function (PutBucketTaggingRequest) {
    PutBucketTaggingRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketTaggingRequest.isa = function (o) { return __isa(o, "PutBucketTaggingRequest"); };
})(PutBucketTaggingRequest || (PutBucketTaggingRequest = {}));
export var PutBucketVersioningRequest;
(function (PutBucketVersioningRequest) {
    PutBucketVersioningRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketVersioningRequest.isa = function (o) { return __isa(o, "PutBucketVersioningRequest"); };
})(PutBucketVersioningRequest || (PutBucketVersioningRequest = {}));
export var PutBucketWebsiteRequest;
(function (PutBucketWebsiteRequest) {
    PutBucketWebsiteRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutBucketWebsiteRequest.isa = function (o) { return __isa(o, "PutBucketWebsiteRequest"); };
})(PutBucketWebsiteRequest || (PutBucketWebsiteRequest = {}));
export var PutObjectAclOutput;
(function (PutObjectAclOutput) {
    PutObjectAclOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutObjectAclOutput.isa = function (o) { return __isa(o, "PutObjectAclOutput"); };
})(PutObjectAclOutput || (PutObjectAclOutput = {}));
export var PutObjectAclRequest;
(function (PutObjectAclRequest) {
    PutObjectAclRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutObjectAclRequest.isa = function (o) { return __isa(o, "PutObjectAclRequest"); };
})(PutObjectAclRequest || (PutObjectAclRequest = {}));
export var PutObjectLegalHoldOutput;
(function (PutObjectLegalHoldOutput) {
    PutObjectLegalHoldOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutObjectLegalHoldOutput.isa = function (o) { return __isa(o, "PutObjectLegalHoldOutput"); };
})(PutObjectLegalHoldOutput || (PutObjectLegalHoldOutput = {}));
export var PutObjectLegalHoldRequest;
(function (PutObjectLegalHoldRequest) {
    PutObjectLegalHoldRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutObjectLegalHoldRequest.isa = function (o) { return __isa(o, "PutObjectLegalHoldRequest"); };
})(PutObjectLegalHoldRequest || (PutObjectLegalHoldRequest = {}));
export var PutObjectLockConfigurationOutput;
(function (PutObjectLockConfigurationOutput) {
    PutObjectLockConfigurationOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutObjectLockConfigurationOutput.isa = function (o) { return __isa(o, "PutObjectLockConfigurationOutput"); };
})(PutObjectLockConfigurationOutput || (PutObjectLockConfigurationOutput = {}));
export var PutObjectLockConfigurationRequest;
(function (PutObjectLockConfigurationRequest) {
    PutObjectLockConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutObjectLockConfigurationRequest.isa = function (o) { return __isa(o, "PutObjectLockConfigurationRequest"); };
})(PutObjectLockConfigurationRequest || (PutObjectLockConfigurationRequest = {}));
export var PutObjectOutput;
(function (PutObjectOutput) {
    PutObjectOutput.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING })), (obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING }))); };
    PutObjectOutput.isa = function (o) { return __isa(o, "PutObjectOutput"); };
})(PutObjectOutput || (PutObjectOutput = {}));
export var PutObjectRequest;
(function (PutObjectRequest) {
    PutObjectRequest.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign(__assign({}, obj), (obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING })), (obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING })), (obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING }))); };
    PutObjectRequest.isa = function (o) { return __isa(o, "PutObjectRequest"); };
})(PutObjectRequest || (PutObjectRequest = {}));
export var PutObjectRetentionOutput;
(function (PutObjectRetentionOutput) {
    PutObjectRetentionOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutObjectRetentionOutput.isa = function (o) { return __isa(o, "PutObjectRetentionOutput"); };
})(PutObjectRetentionOutput || (PutObjectRetentionOutput = {}));
export var PutObjectRetentionRequest;
(function (PutObjectRetentionRequest) {
    PutObjectRetentionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutObjectRetentionRequest.isa = function (o) { return __isa(o, "PutObjectRetentionRequest"); };
})(PutObjectRetentionRequest || (PutObjectRetentionRequest = {}));
export var PutObjectTaggingOutput;
(function (PutObjectTaggingOutput) {
    PutObjectTaggingOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutObjectTaggingOutput.isa = function (o) { return __isa(o, "PutObjectTaggingOutput"); };
})(PutObjectTaggingOutput || (PutObjectTaggingOutput = {}));
export var PutObjectTaggingRequest;
(function (PutObjectTaggingRequest) {
    PutObjectTaggingRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutObjectTaggingRequest.isa = function (o) { return __isa(o, "PutObjectTaggingRequest"); };
})(PutObjectTaggingRequest || (PutObjectTaggingRequest = {}));
export var PutPublicAccessBlockRequest;
(function (PutPublicAccessBlockRequest) {
    PutPublicAccessBlockRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutPublicAccessBlockRequest.isa = function (o) { return __isa(o, "PutPublicAccessBlockRequest"); };
})(PutPublicAccessBlockRequest || (PutPublicAccessBlockRequest = {}));
export var QueueConfiguration;
(function (QueueConfiguration) {
    QueueConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    QueueConfiguration.isa = function (o) { return __isa(o, "QueueConfiguration"); };
})(QueueConfiguration || (QueueConfiguration = {}));
export var QuoteFields;
(function (QuoteFields) {
    QuoteFields["ALWAYS"] = "ALWAYS";
    QuoteFields["ASNEEDED"] = "ASNEEDED";
})(QuoteFields || (QuoteFields = {}));
export var RecordsEvent;
(function (RecordsEvent) {
    RecordsEvent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RecordsEvent.isa = function (o) { return __isa(o, "RecordsEvent"); };
})(RecordsEvent || (RecordsEvent = {}));
export var Redirect;
(function (Redirect) {
    Redirect.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Redirect.isa = function (o) { return __isa(o, "Redirect"); };
})(Redirect || (Redirect = {}));
export var RedirectAllRequestsTo;
(function (RedirectAllRequestsTo) {
    RedirectAllRequestsTo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RedirectAllRequestsTo.isa = function (o) { return __isa(o, "RedirectAllRequestsTo"); };
})(RedirectAllRequestsTo || (RedirectAllRequestsTo = {}));
export var ReplicationConfiguration;
(function (ReplicationConfiguration) {
    ReplicationConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ReplicationConfiguration.isa = function (o) { return __isa(o, "ReplicationConfiguration"); };
})(ReplicationConfiguration || (ReplicationConfiguration = {}));
export var ReplicationRule;
(function (ReplicationRule) {
    ReplicationRule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ReplicationRule.isa = function (o) { return __isa(o, "ReplicationRule"); };
})(ReplicationRule || (ReplicationRule = {}));
export var ReplicationRuleAndOperator;
(function (ReplicationRuleAndOperator) {
    ReplicationRuleAndOperator.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ReplicationRuleAndOperator.isa = function (o) { return __isa(o, "ReplicationRuleAndOperator"); };
})(ReplicationRuleAndOperator || (ReplicationRuleAndOperator = {}));
export var ReplicationRuleFilter;
(function (ReplicationRuleFilter) {
    ReplicationRuleFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ReplicationRuleFilter.isa = function (o) { return __isa(o, "ReplicationRuleFilter"); };
})(ReplicationRuleFilter || (ReplicationRuleFilter = {}));
export var ReplicationTime;
(function (ReplicationTime) {
    ReplicationTime.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ReplicationTime.isa = function (o) { return __isa(o, "ReplicationTime"); };
})(ReplicationTime || (ReplicationTime = {}));
export var ReplicationTimeValue;
(function (ReplicationTimeValue) {
    ReplicationTimeValue.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ReplicationTimeValue.isa = function (o) { return __isa(o, "ReplicationTimeValue"); };
})(ReplicationTimeValue || (ReplicationTimeValue = {}));
export var RequestPaymentConfiguration;
(function (RequestPaymentConfiguration) {
    RequestPaymentConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RequestPaymentConfiguration.isa = function (o) { return __isa(o, "RequestPaymentConfiguration"); };
})(RequestPaymentConfiguration || (RequestPaymentConfiguration = {}));
export var RequestProgress;
(function (RequestProgress) {
    RequestProgress.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RequestProgress.isa = function (o) { return __isa(o, "RequestProgress"); };
})(RequestProgress || (RequestProgress = {}));
export var RestoreObjectOutput;
(function (RestoreObjectOutput) {
    RestoreObjectOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RestoreObjectOutput.isa = function (o) { return __isa(o, "RestoreObjectOutput"); };
})(RestoreObjectOutput || (RestoreObjectOutput = {}));
export var RestoreObjectRequest;
(function (RestoreObjectRequest) {
    RestoreObjectRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.RestoreRequest && { RestoreRequest: RestoreRequest.filterSensitiveLog(obj.RestoreRequest) }))); };
    RestoreObjectRequest.isa = function (o) { return __isa(o, "RestoreObjectRequest"); };
})(RestoreObjectRequest || (RestoreObjectRequest = {}));
export var RestoreRequest;
(function (RestoreRequest) {
    RestoreRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.OutputLocation && { OutputLocation: OutputLocation.filterSensitiveLog(obj.OutputLocation) }))); };
    RestoreRequest.isa = function (o) { return __isa(o, "RestoreRequest"); };
})(RestoreRequest || (RestoreRequest = {}));
export var RestoreRequestType;
(function (RestoreRequestType) {
    RestoreRequestType["SELECT"] = "SELECT";
})(RestoreRequestType || (RestoreRequestType = {}));
export var RoutingRule;
(function (RoutingRule) {
    RoutingRule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RoutingRule.isa = function (o) { return __isa(o, "RoutingRule"); };
})(RoutingRule || (RoutingRule = {}));
export var S3KeyFilter;
(function (S3KeyFilter) {
    S3KeyFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    S3KeyFilter.isa = function (o) { return __isa(o, "S3KeyFilter"); };
})(S3KeyFilter || (S3KeyFilter = {}));
export var S3Location;
(function (S3Location) {
    S3Location.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Encryption && { Encryption: Encryption.filterSensitiveLog(obj.Encryption) }))); };
    S3Location.isa = function (o) { return __isa(o, "S3Location"); };
})(S3Location || (S3Location = {}));
export var ScanRange;
(function (ScanRange) {
    ScanRange.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ScanRange.isa = function (o) { return __isa(o, "ScanRange"); };
})(ScanRange || (ScanRange = {}));
export var SelectObjectContentEventStream;
(function (SelectObjectContentEventStream) {
    SelectObjectContentEventStream.visit = function (value, visitor) {
        if (value.Stats !== undefined)
            return visitor.Stats(value.Stats);
        if (value.End !== undefined)
            return visitor.End(value.End);
        if (value.Progress !== undefined)
            return visitor.Progress(value.Progress);
        if (value.Records !== undefined)
            return visitor.Records(value.Records);
        if (value.Cont !== undefined)
            return visitor.Cont(value.Cont);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    SelectObjectContentEventStream.filterSensitiveLog = function (obj) {
        var _a;
        if (obj.Stats !== undefined)
            return { Stats: StatsEvent.filterSensitiveLog(obj.Stats) };
        if (obj.End !== undefined)
            return { End: EndEvent.filterSensitiveLog(obj.End) };
        if (obj.Progress !== undefined)
            return { Progress: ProgressEvent.filterSensitiveLog(obj.Progress) };
        if (obj.Records !== undefined)
            return { Records: RecordsEvent.filterSensitiveLog(obj.Records) };
        if (obj.Cont !== undefined)
            return { Cont: ContinuationEvent.filterSensitiveLog(obj.Cont) };
        if (obj.$unknown !== undefined)
            return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})(SelectObjectContentEventStream || (SelectObjectContentEventStream = {}));
export var SelectObjectContentOutput;
(function (SelectObjectContentOutput) {
    SelectObjectContentOutput.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Payload && { Payload: "STREAMING_CONTENT" }))); };
    SelectObjectContentOutput.isa = function (o) { return __isa(o, "SelectObjectContentOutput"); };
})(SelectObjectContentOutput || (SelectObjectContentOutput = {}));
export var SelectObjectContentRequest;
(function (SelectObjectContentRequest) {
    SelectObjectContentRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING }))); };
    SelectObjectContentRequest.isa = function (o) { return __isa(o, "SelectObjectContentRequest"); };
})(SelectObjectContentRequest || (SelectObjectContentRequest = {}));
export var SelectParameters;
(function (SelectParameters) {
    SelectParameters.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SelectParameters.isa = function (o) { return __isa(o, "SelectParameters"); };
})(SelectParameters || (SelectParameters = {}));
export var ServerSideEncryptionByDefault;
(function (ServerSideEncryptionByDefault) {
    ServerSideEncryptionByDefault.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.KMSMasterKeyID && { KMSMasterKeyID: SENSITIVE_STRING }))); };
    ServerSideEncryptionByDefault.isa = function (o) { return __isa(o, "ServerSideEncryptionByDefault"); };
})(ServerSideEncryptionByDefault || (ServerSideEncryptionByDefault = {}));
export var ServerSideEncryptionConfiguration;
(function (ServerSideEncryptionConfiguration) {
    ServerSideEncryptionConfiguration.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Rules && { Rules: obj.Rules.map(function (item) { return ServerSideEncryptionRule.filterSensitiveLog(item); }) }))); };
    ServerSideEncryptionConfiguration.isa = function (o) { return __isa(o, "ServerSideEncryptionConfiguration"); };
})(ServerSideEncryptionConfiguration || (ServerSideEncryptionConfiguration = {}));
export var ServerSideEncryptionRule;
(function (ServerSideEncryptionRule) {
    ServerSideEncryptionRule.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ApplyServerSideEncryptionByDefault && {
        ApplyServerSideEncryptionByDefault: ServerSideEncryptionByDefault.filterSensitiveLog(obj.ApplyServerSideEncryptionByDefault),
    }))); };
    ServerSideEncryptionRule.isa = function (o) { return __isa(o, "ServerSideEncryptionRule"); };
})(ServerSideEncryptionRule || (ServerSideEncryptionRule = {}));
export var SourceSelectionCriteria;
(function (SourceSelectionCriteria) {
    SourceSelectionCriteria.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SourceSelectionCriteria.isa = function (o) { return __isa(o, "SourceSelectionCriteria"); };
})(SourceSelectionCriteria || (SourceSelectionCriteria = {}));
export var SSEKMS;
(function (SSEKMS) {
    SSEKMS.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.KeyId && { KeyId: SENSITIVE_STRING }))); };
    SSEKMS.isa = function (o) { return __isa(o, "SSEKMS"); };
})(SSEKMS || (SSEKMS = {}));
export var SseKmsEncryptedObjects;
(function (SseKmsEncryptedObjects) {
    SseKmsEncryptedObjects.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SseKmsEncryptedObjects.isa = function (o) { return __isa(o, "SseKmsEncryptedObjects"); };
})(SseKmsEncryptedObjects || (SseKmsEncryptedObjects = {}));
export var SSES3;
(function (SSES3) {
    SSES3.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SSES3.isa = function (o) { return __isa(o, "SSES3"); };
})(SSES3 || (SSES3 = {}));
export var Stats;
(function (Stats) {
    Stats.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Stats.isa = function (o) { return __isa(o, "Stats"); };
})(Stats || (Stats = {}));
export var StatsEvent;
(function (StatsEvent) {
    StatsEvent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StatsEvent.isa = function (o) { return __isa(o, "StatsEvent"); };
})(StatsEvent || (StatsEvent = {}));
export var StorageClassAnalysis;
(function (StorageClassAnalysis) {
    StorageClassAnalysis.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StorageClassAnalysis.isa = function (o) { return __isa(o, "StorageClassAnalysis"); };
})(StorageClassAnalysis || (StorageClassAnalysis = {}));
export var StorageClassAnalysisDataExport;
(function (StorageClassAnalysisDataExport) {
    StorageClassAnalysisDataExport.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StorageClassAnalysisDataExport.isa = function (o) { return __isa(o, "StorageClassAnalysisDataExport"); };
})(StorageClassAnalysisDataExport || (StorageClassAnalysisDataExport = {}));
export var Tag;
(function (Tag) {
    Tag.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Tag.isa = function (o) { return __isa(o, "Tag"); };
})(Tag || (Tag = {}));
export var Tagging;
(function (Tagging) {
    Tagging.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Tagging.isa = function (o) { return __isa(o, "Tagging"); };
})(Tagging || (Tagging = {}));
export var TargetGrant;
(function (TargetGrant) {
    TargetGrant.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TargetGrant.isa = function (o) { return __isa(o, "TargetGrant"); };
})(TargetGrant || (TargetGrant = {}));
export var TopicConfiguration;
(function (TopicConfiguration) {
    TopicConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TopicConfiguration.isa = function (o) { return __isa(o, "TopicConfiguration"); };
})(TopicConfiguration || (TopicConfiguration = {}));
export var Transition;
(function (Transition) {
    Transition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Transition.isa = function (o) { return __isa(o, "Transition"); };
})(Transition || (Transition = {}));
export var UploadPartCopyOutput;
(function (UploadPartCopyOutput) {
    UploadPartCopyOutput.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING }))); };
    UploadPartCopyOutput.isa = function (o) { return __isa(o, "UploadPartCopyOutput"); };
})(UploadPartCopyOutput || (UploadPartCopyOutput = {}));
export var UploadPartCopyRequest;
(function (UploadPartCopyRequest) {
    UploadPartCopyRequest.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.CopySourceSSECustomerKey && { CopySourceSSECustomerKey: SENSITIVE_STRING })), (obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING }))); };
    UploadPartCopyRequest.isa = function (o) { return __isa(o, "UploadPartCopyRequest"); };
})(UploadPartCopyRequest || (UploadPartCopyRequest = {}));
export var UploadPartOutput;
(function (UploadPartOutput) {
    UploadPartOutput.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING }))); };
    UploadPartOutput.isa = function (o) { return __isa(o, "UploadPartOutput"); };
})(UploadPartOutput || (UploadPartOutput = {}));
export var UploadPartRequest;
(function (UploadPartRequest) {
    UploadPartRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING }))); };
    UploadPartRequest.isa = function (o) { return __isa(o, "UploadPartRequest"); };
})(UploadPartRequest || (UploadPartRequest = {}));
export var VersioningConfiguration;
(function (VersioningConfiguration) {
    VersioningConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    VersioningConfiguration.isa = function (o) { return __isa(o, "VersioningConfiguration"); };
})(VersioningConfiguration || (VersioningConfiguration = {}));
export var WebsiteConfiguration;
(function (WebsiteConfiguration) {
    WebsiteConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    WebsiteConfiguration.isa = function (o) { return __isa(o, "WebsiteConfiguration"); };
})(WebsiteConfiguration || (WebsiteConfiguration = {}));
//# sourceMappingURL=index.js.map